"use client";
import { useState, useEffect, useCallback } from "react";
import { useGlobalContext } from "../../../../app/context/store";
import { IS_MAIN_SITE } from "../../../shared/sites/sites";
import { useSignInModal } from "./sign-in-modal";
import Image from "next/image";
import { QueueType, useGenerator } from "@/app/context/GeneratorContext";
import { gifReady } from "@/components/shared/generators/generators";
import { getResolutions } from "@/lib/utils/getResolutions";
import { isSDXL } from "@/components/shared/generators/isSDXL";

// interface MenuBarTranslations {

// }

interface SignInModalTranslations {
  signIn: string;
  signInDescription: string;
  signInButton: string;
  copy: string;
  copied: string;
  toolTip1: string;
  toolTip2: string;
  toolTip3: string;
}

export default function Generation({
  translations,
  signInModalTranslations,
}: {
  translations: any;
  signInModalTranslations: any;
}) {
  const { user } = useGlobalContext();
  const { state, tagList, setTagList, setQueueType, setGenerationType } = useGenerator();
  const [copyUrl, setCopyUrl] = useState("");
  const { SignInModal, setShowSignInModal } = useSignInModal(
    signInModalTranslations,
    // {
    //   signInModalSignIn: locale.signInModal.signIn,
    //   signInModalSignInDescription: locale.signInModal.signInDescription,
    //   signInModalSignInButton: locale.signInModal.signInButton,
    //   copy: locale.share.copy,
    //   copied: locale.share.copied,
    // },
    copyUrl,
  );

  //set all tags to false
  const resetTags = useCallback(() => {
    let newTagList = tagList.map((tagSet: any) => {
      let newListOfToggles = tagSet.tags.map((tag: any) => {
        return { ...tag, selected: false };
      });
      return { ...tagSet, tags: newListOfToggles };
    });
    setTagList(newTagList);
  }, [tagList]);

  //copy a list of selected tags
  const getSelectedTags = useCallback(
    (data: any) => {
      let selectedTags = data
        .flatMap((item: any) => item.tags)
        .filter((tag: any) => tag.selected)
        .map((tag: any) => tag.id)
        .join(", ");
      //console.log(selectedTags);
      selectedTags = selectedTags.replace(/\s/g, "");
      //Change resolution value to aspectRatio string to match clone logic
      const isPony = isSDXL(state.selectedGenerator.shortName || "style");
      const resolutions = getResolutions(isPony);
      const aspectRatio = resolutions.find((res) => state.resolution === res.value);
      let tagURLString =
        process.env.NEXT_PUBLIC_BASE_URL +
        translations.path +
        "create?style=" +
        state.selectedGenerator.shortName +
        "&resolution=" +
        aspectRatio?.string +
        "&tags=" +
        selectedTags +
        "&prompt=" +
        encodeURIComponent(state.customPrompt);
      setCopyUrl(tagURLString);
      setShowSignInModal(true);
    },
    [state.customPrompt, state.selectedGenerator._id, tagList],
  );

  useEffect(() => {
    let creditSum = IS_MAIN_SITE
      ? user.credits.ccBill + user.credits.subStar + user.credits.daily
      : user.credits.subStar + user.credits.niche + user.credits.daily;
    // if (state.imageLoadingState == 2 || state.imageLoadingState == 0) {
    // }
    if (creditSum >= 550) {
      setQueueType(QueueType.Turbo);
    }
    if (creditSum < 550) {
      setQueueType(QueueType.Free);
    }
  }, [user]);

  return (
    <>
      <SignInModal />
      <div className="px-0">
        <div className="flex flex-row px-5 sm:px-0">
          <div className="text-sm font-bold text-white">{translations.menu}</div>
          <button
            className="font-white ml-auto text-sm font-bold text-[#6CB4F4]"
            onClick={() => {
              getSelectedTags(tagList);
            }}
          >
            {translations.copyTags}
          </button>
          <button
            className="font-white ml-4 text-sm font-bold text-[#6CB4F4]"
            onClick={() => resetTags()}
          >
            {translations.clearTags}
          </button>
        </div>
        {user?.membership?.level !== -1 ? (
          <>
            <div className="mb-4 mt-5 flex flex-row border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] px-5 py-3 sm:mb-0 sm:rounded-tl-lg sm:rounded-tr-lg sm:px-5">
              <div className="mx-auto flex flex-row justify-center">
                <button
                  className={`rounded-md py-1 pr-4 text-sm font-bold ${
                    state.generationType === "image" ? "text-white" : "text-gray-300"
                  }`}
                  onClick={() => setGenerationType("image")}
                >
                  {translations.image}
                </button>
                {gifReady ? (
                  <>
                    {" "}
                    <div className="my-auto h-5 w-[1px] bg-grey-outline" />
                    <button
                      className={`rounded-md py-1 pl-4 text-sm font-bold ${
                        state.generationType === "gif" ? "text-white" : "text-gray-300"
                      }`}
                      onClick={() => setGenerationType("gif")}
                    >
                      {translations.gif} {translations.beta}
                    </button>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
            {state.generationType === "image" ? (
              <>
                {" "}
                <div className="mb-4 flex flex-row border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] px-5 py-3 sm:mb-0 sm:px-5">
                  <div className="flex flex-row items-center">
                    {/* <div className="text-[8px] ml-0.5 mr-1">💎</div> */}
                    <Image
                      className="mr-2.5 rounded-md object-cover"
                      src={
                        IS_MAIN_SITE
                          ? "https://cdn6.imgpog.com/ruby.webp"
                          : "https://cdn6.imgpog.com/diamond.webp"
                      }
                      alt="Gem"
                      width={14}
                      height={14}
                      unoptimized
                    />
                    <div className="flex flex-col">
                      <div className="text-sm font-bold text-white">{translations.turboGen}</div>
                      <div className="text-xs text-white sm:text-sm">
                        {translations.turboGenDescription}
                      </div>
                    </div>
                  </div>
                  <label className="ml-auto inline-flex cursor-pointer items-center">
                    <input
                      type="checkbox"
                      checked={state.queueType === QueueType.Turbo}
                      className="peer sr-only"
                      onChange={() => {
                        if (state.queueType === QueueType.Free) {
                          setQueueType(QueueType.Turbo);
                        } else {
                          setQueueType(QueueType.Free);
                        }
                      }}
                    />
                    <div className="peer-checked:after:border-grey-600 peer relative h-6 w-11 rounded-full bg-gray-700 after:absolute after:start-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] focus:outline-none focus-visible:outline-none peer-checked:bg-[#0772DD] peer-checked:after:translate-x-full peer-focus:outline-none peer-focus:ring-0 rtl:peer-checked:after:-translate-x-full"></div>
                  </label>
                </div>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <div className="mb-5"></div>
        )}
      </div>
    </>
  );
}
